import type { ComponentType } from 'react';

import AppleIcon from '@cartwhl/ui/icons/AppleIcon';
import WindowsIcon from '@cartwhl/ui/icons/WindowsIcon';

import type { BrandIconProps } from '@cartwhl/ui/icons/brandIconTypes';
import type { PluginDownloadOption, PluginPlatform } from './integrationsPageData';

export const pluginPlatformIcons: Record<
  PluginPlatform,
  ComponentType<BrandIconProps>
> = {
  windows: WindowsIcon,
  macos: AppleIcon,
};

export function detectPluginPlatform(): PluginPlatform {
  if (typeof navigator === 'undefined') {
    return 'windows';
  }

  const userAgent = navigator.userAgent.toLowerCase();
  const platform = navigator.platform?.toLowerCase() ?? '';

  if (
    /mac|darwin|iphone|ipad|ipod/.test(userAgent) ||
    platform.includes('mac')
  ) {
    return 'macos';
  }

  return 'windows';
}

export const pluginPlatformHeaderLabels: Record<PluginPlatform, string> = {
  windows: 'Windows',
  macos: 'Mac',
};

export function getPluginVersionMenuLabel(option: PluginDownloadOption): string {
  return `Unreal Engine ${option.unrealVersion}`;
}

export function groupPluginDownloadOptionsByPlatform(
  options: PluginDownloadOption[],
): PluginDownloadOption[][] {
  const platforms: PluginPlatform[] = ['windows', 'macos'];

  return platforms
    .map((platform) =>
      options.filter((option) => option.platform === platform),
    )
    .filter((group) => group.length > 0);
}

export function getDefaultDownloadOption(
  options: PluginDownloadOption[],
  platform: PluginPlatform = detectPluginPlatform(),
): PluginDownloadOption {
  const platformOptions = options.filter((option) => option.platform === platform);

  if (platformOptions.length > 0) {
    return platformOptions[platformOptions.length - 1];
  }

  return options[options.length - 1];
}
